class ShelfProductTagImageController {
    constructor(shelfProductService, analytics) {
        this.shelfProductService = shelfProductService;
        this.analytics = analytics;
    }

    tagClick(event) {
        // addToTrolley or addMultipleToTrolley are not links anymore
        // they prevent the link to follow href
        if (this.shelfProductService.processTrolleyProductTagLink(this.product.ImageTag.TagLink)) {
            event.preventDefault();
        }

        this.analytics.push({ data: this.product, type: this.analytics.mapperTypes.customEvent.productClick });
    }

    gtmStaticTagClickPush() {
        this.analytics.pushEvent('staticTagImageClick');
    }
}

const shelfProductTagImageComponentDefinition = {
    bindings: {
        product: '<',
    },
    controller: ['ShelfProductService', 'AnalyticsService', ShelfProductTagImageController],
    template: require('./shelf-product-tag-image.component.html').trim(),
};

module.exports = {
    ShelfProductTagImageController,
    shelfProductTagImageComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/shelf-product-tag/shelf-product-tag-image.component.js